import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';

const AdminGuard = (props) => {
  const { children } = props;

  const { isAuthenticated, user } = useAuth();

  // is not authenticated -> login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  // is authenticated and does not have admin role -> 401
  if (user?.role !== 'admin') {
    return <Navigate to="/status/401" />;
  }

  // is authenticated and has admin role -> show page/content
  return <>{children}</>;
};

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default AdminGuard;
